import arController from '@/infra/BirdId/controllers/ar.controller'
import { RemovableRef, useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

export type ArDataType = {
  subdomain?: string
  nomeAr: string
  logo: string
  siteAR: string
  foneAR: string
  emissorLink: string
  sub: string
}

type State = {
  arData: RemovableRef<ArDataType>
}

export const useAR = defineStore('arStore', {
  state: () =>
    ({
      arData: useStorage('arData', {
        subdomain: '',
        nomeAr: '',
        logo: '',
        foneAR: '',
        siteAR: '',
        emissorLink: '',
        sub: '',
      }),
    }) as State,
  actions: {
    async fetchAraData(arsubdomain: string) {
      const arData = await arController.getArData(arsubdomain)
      this.arData = { ...arData.data, subdomain: arsubdomain, sub: '' }
    },
    setArData(payload: ArDataType) {
      this.arData = { ...payload, sub: payload.sub || '' }
    },
    setSub(sub: string) {
      Object.assign(this.arData, { sub })
    },
  },
  getters: {
    getSubdomain(): string {
      return this.arData.subdomain || ''
    },
    getLinkEmissor(): string {
      if (this.arData.subdomain) {
        return `https://${this.arData.subdomain}.acsoluti.com.br/jnlp/emissor`
      }

      if (this.arData.emissorLink) {
        return this.arData.emissorLink
      }

      return 'https://emissor.ca.inf.br/prod/Emissor.jnlp'
    },
    getSiteArFormatted(): string {
      if (!this.arData.siteAR) {
        return ''
      }

      const siteAR = this.arData.siteAR
        .replace(/^https?:\/\//, '') // remove http:// ou https://caso exista
        .replace(/\/$/, '') // remove barra no final da URL

      return siteAR
    },
    getSub(): string {
      return this.arData.sub
    },
  },
})
